/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

const FileSelectorComponent = ({ children, id, ...props }) => (
    <>
        <input
            {...props}
            type="file"
            id={(id) ? id : "imgUpload"}
            style={{
                display: 'none',
            }}
        />
        <label htmlFor={(id) ? id : "imgUpload"}>
            {children}
        </label>
    </>
);

FileSelectorComponent.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any,
};
FileSelectorComponent.defaultProps = {
    children: null,
    id: null,
};

export default FileSelectorComponent;
